<template>
	<div style="margin: 20px;">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/systemSetupList/systemSetup'}">系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>活动申报与审批流程</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 选择申报方式 -->
		<div class="flow-box">
			<div class="flow-title">
				<span>店铺 & 经销商申报活动的方式</span>
			</div>
			<el-card :body-style="{ padding: '20px' }" class="flow-card">
				<el-row>
				  <el-col :span="18">
						<el-checkbox-group
							v-model="selectApproval"
							@change="checkboxClick">
							<el-checkbox
								v-for="(approval, index) in approrvalOptions"
								:label="approval.value"
								:key="index"
								:disabled="typeShow == true">
								{{approval.text}}
							</el-checkbox>
						</el-checkbox-group>
					</el-col>
				  <el-col :span="6">
						<div class="buttonStyle" v-if="typeShow == false" @click="onCancelApprovalWay">取 消</div>
						<div class="buttonStyle" v-if="typeShow == false" @click="onApprovalWayChange">保 存</div>
						<div class="buttonStyle" v-if="typeShow == true" @click="onEditApprovalWay">编 辑</div>
					</el-col>
				</el-row>
			</el-card>
		</div>
		<!-- 设置申报字段 -->
		<div class="flow-box">
			<div class="flow-title">
				<span>店铺 & 经销商申报活动时需填写的信息</span>
			</div>
			<prodectDialog v-if="this.selectApproval.includes('campaignproduct')"/>
			<urlDialog v-if="this.selectApproval.includes('campaignlink')"/>
			<ShopDialog v-if="this.selectApproval.includes('campaignshop')"/>

		</div>
		<!-- 设置审批流程 -->
		<div class="flow-box">
			<div class="flow-title">
				<span>活动审批流程设置</span>
			</div>
			<el-card
				v-for="(flow, index) in approvalFlowOptions"
				:key="index"
				:body-style="{ padding: '20px' }"
				class="flow-card"
				v-if="flow.showSet">
				<div class="flow-approval-wrap">
					<div>
						<span class="flow-approval-text">{{ flow.title }}</span>
						<span v-if="!flow.hasSet">
							<i class="el-icon-info flow-approval-text-icon"></i>
							<span>未设置</span>
						</span>
					</div>
					<div :class="index !== 0 && 'set-box'">
						<span
							@click="copyFlow(index === 1 ? '2' : '1')"
							v-if="index !== 0"
							:class="approvalFlowOptions[index === 1 ? 2 : 1].hasSet ? 'copy-text' : 'copy-disable-text'">
						复制{{ index === 1 ? '全店铺申报' : '按链接申报' }}的流程
						</span>
						<span @click="onOpenSelectFlowDialog(index)" class="flow-approval-btn">{{ flow.hasSet ? '修改设置' : '去设置' }}</span>
					</div>

				</div>
			</el-card>
		</div>
		<!-- <FlowDialog
			v-show="false"
			:way="approvalWay"
			ref="childFlowDialog"
		/> -->
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import FlowDialog from './flowDialog';
import prodectDialog from './prodectDialog';
import urlDialog from './urlDialog';
import ShopDialog from './ShopDialog';
export default {
	name: 'activityFlow',

	components:{
		// FlowDialog,
		prodectDialog,
		urlDialog,
		ShopDialog,
	},

	data () {
		return {
			typeShow: true,//编辑
			approvalWay: '',
			approvalVisible: false,
			selectApproval: [],
			// 缓存已选申报方式，点击取消时可以回退
			cacheSelcetApproval: [],
			approrvalOptions: [
				{ text: '按产品申报活动', value: 'campaignproduct' },
				{ text: '按链接申报活动', value: 'campaignlink' },
				{ text: '全店铺申报活动', value: 'campaignshop' },
			],
			approvalFlowOptions: [
				{ key: 'campaignproduct', title: '按产品申报活动', hasSet: false, showSet: false, },
				{ key: 'campaignlink', title: '按链接申报活动', hasSet: false, showSet: false, },
				{ key: 'campaignshop', title: '全店铺申报活动', hasSet: false, showSet: false, },
			],
			titleList: [],
		}
	},

	methods: {
		async copyFlow(flag) {
			const data = {
				type: flag === '2' ? '2' : '1',
				declaremeans: flag === '2' ? '1' : '2',
			}
			const res = await fetch({
        url: "hcm/hcmApproval/saveHcmApprovalTempletBmcid",
        method: "post",
        data
			})

			if(res.status === '11002') {
				this.$message.error(res.message);
			}
			if(res.status === '10000') {
				this.$message.success('流程复制成功!');
				this.reqApprovalConfig()
			}
		},
		onCancelApprovalWay() {
			this.typeShow = true;
			this.selectApproval = this.cacheSelcetApproval;
		},
		onEditApprovalWay() {
			this.typeShow = false;
			this.cacheSelcetApproval = this.selectApproval;
		},
		...mapActions([
			'reqActivityFlowWay'
		]),
		// onCloseFlowDialog() {
		// 	this.approvalVisible = false;
		// },
		onOpenSelectFlowDialog(index) {
			this.approvalWay = this.approvalFlowOptions[index].key;
			this.$router.push({path:"/activityApprovalSetting",query:{id: index + 2,flowId: 1,approvalWay: this.approvalWay}})
		},
		// 点击判断是什么活动
		checkboxClick() {
			// 初始化为false
			for (var i = 0; i < this.approvalFlowOptions.length; i++) {
				this.approvalFlowOptions[i].showSet = false
			}
			for (var i = 0; i < this.approvalFlowOptions.length; i++) {
				for (var b = 0; b < this.selectApproval.length; b++) {
					if (this.approvalFlowOptions[i].key == this.selectApproval[b]) {
						this.approvalFlowOptions[i].showSet = true
					}
				}
			}
		},
		async onApprovalWayChange(val) {
			if (this.selectApproval.length < 1) {
				this.$message({
          message: '请至少选择一种申报方式',
          type: 'warning'
        });
				return
			}
			const params = {
				campaignproduct: this.selectApproval.includes('campaignproduct') ? 1 : 0,
				campaignlink: this.selectApproval.includes('campaignlink') ? 1 : 0,
				campaignshop: this.selectApproval.includes('campaignshop') ? 1 : 0,
			}
			await fetch({
        url: "hcm/cus/updatecamptype",
        method: "post",
        data:params
			})
			this.$message.success('修改活动申报方式成功');
			this.typeShow = true
			this.reqApprovalConfig();
		},
		async reqApprovalConfig() {
			const { data } = await fetch({
        url: "hcm/hcmApproval/getConfiguration",
        method: "get",
			})
			this.approvalFlowOptions.map(item => {
				data[item.key] ? item.hasSet = true : item.hasSet = false;
				return item;
			})
		}
	},

	computed: {},

	async mounted(){
		const { campaignproduct, campaignlink, campaignshop } = await this.reqActivityFlowWay();
		this.reqApprovalConfig();
		this.selectApproval = [];
		campaignproduct === 1 && this.selectApproval.push('campaignproduct');
		campaignlink === 1 && this.selectApproval.push('campaignlink');
		campaignshop === 1 && this.selectApproval.push('campaignshop');
		this.titleList = this.selectApproval
		console.log(this.selectApproval)
		this.checkboxClick()
	}
}
</script>

<style lang="scss">
@import 'style/activityFlow.scss';
</style>
